import React, { useEffect, useState } from 'react';
import { UserPlus, Trash2, KeyRound, Power, Check, X } from 'lucide-react';
import { api } from '../services/api';
import styles from './SettingsPage.module.css';

// Sezione "Utenti" del pannello Settings — visibile solo all'admin.
// Crea utenti, assegna ruoli, attiva/disattiva, resetta password, elimina.
// La protezione vera è lato server (require_admin); qui è solo UI.
export default function UsersSection() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ username: '', email: '', password: '', role: 'operator' });
  const [resetFor, setResetFor] = useState(null);
  const [resetVal, setResetVal] = useState('');

  const flash = (setter, msg) => { setter(msg); setTimeout(() => setter(''), 3000); };

  const load = async () => {
    try { setUsers(await api.get('/users/')); }
    catch (e) { setError(e.message); }
  };
  useEffect(() => { load(); }, []);

  const createUser = async () => {
    setError('');
    if (!form.username || !form.email || !form.password) { setError('Compila username, email e password'); return; }
    try {
      await api.post('/users/', form);
      setForm({ username: '', email: '', password: '', role: 'operator' });
      setShowForm(false);
      flash(setOk, 'Utente creato');
      load();
    } catch (e) { setError(e.message); }
  };

  const changeRole = async (u, role) => {
    setError('');
    try { await api.patch(`/users/${u.id}`, { role }); flash(setOk, `Ruolo aggiornato: ${u.username}`); load(); }
    catch (e) { setError(e.message); }
  };

  const toggleActive = async (u) => {
    setError('');
    try { await api.patch(`/users/${u.id}`, { is_active: !u.is_active }); load(); }
    catch (e) { setError(e.message); }
  };

  const doReset = async (u) => {
    setError('');
    if (resetVal.length < 6) { setError('La password deve avere almeno 6 caratteri'); return; }
    try {
      await api.post(`/users/${u.id}/reset-password`, { new_password: resetVal });
      setResetFor(null); setResetVal('');
      flash(setOk, `Password resettata: ${u.username}`);
    } catch (e) { setError(e.message); }
  };

  const removeUser = async (u) => {
    setError('');
    if (!window.confirm(`Eliminare l'utente "${u.username}"? L'operazione è irreversibile.`)) return;
    try { await api.delete(`/users/${u.id}`); flash(setOk, 'Utente eliminato'); load(); }
    catch (e) { setError(e.message); }
  };

  return (
    <>
      {error && <p className={styles.msgErr}>{error}</p>}
      {ok && <p className={styles.msgOk}>{ok}</p>}

      {users.map((u) => (
        <div key={u.id} className={styles.userRow}>
          <div className={styles.userMain}>
            <div className={styles.userName}>
              {u.username}
              <span className={`${styles.badge} ${u.role === 'admin' ? styles.badgeAdmin : styles.badgeOperator}`}>
                {u.role}
              </span>
              {!u.is_active && <span className={`${styles.badge} ${styles.badgeOff}`}>disattivo</span>}
            </div>
            <div className={styles.userEmail}>{u.email}</div>
            {resetFor === u.id && (
              <div className={styles.formRow} style={{ marginTop: 8 }}>
                <input
                  className={styles.input}
                  type="password"
                  placeholder="Nuova password (min 6)"
                  value={resetVal}
                  onChange={(e) => setResetVal(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && doReset(u)}
                  autoFocus
                />
                <button className={styles.iconBtn} title="Conferma" onClick={() => doReset(u)}><Check size={14} /></button>
                <button className={styles.iconBtn} title="Annulla" onClick={() => { setResetFor(null); setResetVal(''); }}><X size={14} /></button>
              </div>
            )}
          </div>
          <div className={styles.userActions}>
            <select className={styles.miniSelect} value={u.role} onChange={(e) => changeRole(u, e.target.value)} title="Ruolo">
              <option value="operator">operator</option>
              <option value="admin">admin</option>
            </select>
            <button className={styles.iconBtn} title={u.is_active ? 'Disattiva' : 'Attiva'} onClick={() => toggleActive(u)}><Power size={14} /></button>
            <button className={styles.iconBtn} title="Reset password" onClick={() => { setResetFor(u.id); setResetVal(''); }}><KeyRound size={14} /></button>
            <button className={`${styles.iconBtn} ${styles.iconBtnDanger}`} title="Elimina" onClick={() => removeUser(u)}><Trash2 size={14} /></button>
          </div>
        </div>
      ))}

      {showForm ? (
        <div className={styles.formGrid}>
          <div className={styles.formRow}>
            <input className={styles.input} placeholder="Username" value={form.username}
              onChange={(e) => setForm((p) => ({ ...p, username: e.target.value }))} />
            <input className={styles.input} placeholder="Email" value={form.email}
              onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} />
          </div>
          <div className={styles.formRow}>
            <input className={styles.input} type="password" placeholder="Password (min 6)" value={form.password}
              onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} />
            <select className={styles.select} value={form.role}
              onChange={(e) => setForm((p) => ({ ...p, role: e.target.value }))}>
              <option value="operator">operator</option>
              <option value="admin">admin</option>
            </select>
          </div>
          <div className={styles.formRow}>
            <button className={styles.addBtn} onClick={createUser}><UserPlus size={15} /> Crea utente</button>
            <button className={styles.iconBtn} onClick={() => { setShowForm(false); setError(''); }}>Annulla</button>
          </div>
        </div>
      ) : (
        <button className={styles.addBtn} onClick={() => setShowForm(true)}><UserPlus size={15} /> Nuovo utente</button>
      )}
    </>
  );
}
